module.exports = __webpack_public_path__ + "static/media/workflowtool.76218d57.png";